import { DealWorkflowStageDateMap } from "../../../../../models";
import {
  getInitialWorkflowStageDates,
  normaliseWorkflowTemplatePhases,
  stringKeyToSentenceCase,
} from "../../../../../utils";

export const normaliseStageKey = (phase: string): string => phase.trim().toLowerCase().replace(/\s+/g, "");

export const getStageTitle = (phase: string): string => stringKeyToSentenceCase(phase);

export const getOrderedDealPhases = normaliseWorkflowTemplatePhases;

export const getKeyDateLabel = (keyDate: string): string => {
  const sentenceCaseKeyDate = stringKeyToSentenceCase(keyDate);
  return `${sentenceCaseKeyDate === "Start" || sentenceCaseKeyDate === "End" ? `Stage ${keyDate}` : sentenceCaseKeyDate}`;
};

export const getInitialStageDates = (
  orderedDealPhases: ReturnType<typeof getOrderedDealPhases>,
  existingStageDates: DealWorkflowStageDateMap
): DealWorkflowStageDateMap => getInitialWorkflowStageDates(orderedDealPhases, existingStageDates);
